import { avatar } from './tokens.js';
/** Stable colour pair per person, from the design tokens (all pairs pass WCAG AA). */
export function avatarColors(id) {
    let hash = 0;
    for (const char of id)
        hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
    return avatar[hash % avatar.length];
}
export function initials(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0]?.[0] ?? '?';
    return (parts.length > 1 ? first + parts.at(-1)[0] : first).toLocaleUpperCase('tr');
}
export function firstName(name) {
    return name.trim().split(/\s+/)[0] ?? name;
}
//# sourceMappingURL=people.js.map